export const SLUG_REGEX = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const SLUG_ERROR_MESSAGE =
  "Slug can contain only lowercase letters, numbers and hyphens (-). Spaces, underscores and uppercase letters are not allowed.";

// OLD CODE (was live before, kept for reference - the slug was optional):
// export const slugRules = {
//   validate: (value) =>
//     !value || SLUG_REGEX.test(value) || SLUG_ERROR_MESSAGE,
// };

// NEW CODE (live): react-hook-form rules for the Slug field, it is mandatory now
export const slugRules = {
  required: "Slug is required",
  validate: (value) => SLUG_REGEX.test(value) || SLUG_ERROR_MESSAGE,
};
